import { createSlice, createAction } from '@reduxjs/toolkit';
import { makeFetchSuccessActionType } from '@/utils/makeActionType';
import { VIDEO_URL } from '../actions/common';
export const actionMultiVehicleInfo = createAction('SCREEN_MULTI_VEHICLE');
export const clearMultiVehicleData = createAction('CLEAR_MULTI_VEHICLE_DATA');

const initState: any = {
  pageNum: 0,
  pages: [],
  data: null,
  videoInfoMap: {},
};
const multiVehicleState = createSlice({
  name: 'multiVehicle',
  initialState: initState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(actionMultiVehicleInfo, (state, action: any) => {
        state.data = action.payload.data.list;
        const pageList = [];
        for (let i = 0; i < action.payload.data.pages; i++) {
          pageList.push(i);
        }
        state.pageNum = action.payload.data.pageNum;
        state.pages = pageList;
      })
      .addCase(clearMultiVehicleData, (state, action: any) => {
        state.pageNum = 0;
        state.pages = [];
        state.data = null;
        state.videoInfoMap = {};
      })
      .addCase(makeFetchSuccessActionType(VIDEO_URL), (state, action: any) => {
        action.payload.data?.forEach((item: any) => {
          state.videoInfoMap[item.carId] = item;
        });
      });
  },
});

export default multiVehicleState.reducer;
